import { render, staticRenderFns } from "./CompanyShortlists.vue?vue&type=template&id=19700ad0&"
import script from "./CompanyShortlists.vue?vue&type=script&lang=js&"
export * from "./CompanyShortlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports